<app-iota-modal i18n-title title="Create License" [modalOptions]="modalOptions" (close$)="closeDialog()">
    <div modal-body class="w-full">
        <app-platform-license-form
            [editMode]="true"
            (formValid)="updateFormValidity($event)"
            #platformLicenseForm
        ></app-platform-license-form>
    </div>

    <ng-container modal-footer>
        <div class="w-full flex flex-row items-center justify-between gap-5">
            <button class="btn btn-sm btn-ghost rounded-full flex flex-row items-center gap-2" (click)="closeDialog()">
                <span i18n>Cancel</span>
            </button>

            <button
                class="btn btn-sm btn-primary rounded-full flex flex-row items-center gap-2"
                [ngClass]="{ loading: loading$ | ngrxPush }"
                [disabled]="!formValid"
                (click)="save()"
            >
                <span i18n>Save</span>
            </button>
        </div>
    </ng-container>
</app-iota-modal>
